/* Quiz F&NT — "Encuentra tu rutina"
   Motor de puntos + armado del resultado. Los datos vienen de sections/fnt-quiz.liquid.
   Las tarjetas son las estándar (fnt-product-card): el script solo las mueve al resultado,
   incluido el combo sugerido, que entra como última tarjeta. */
(function () {
  var QUESTIONS = [
    {
      id: 'objetivo',
      options: [
        { v: 'masa', label: 'Ganar masa muscular', desc: 'Más volumen y proteína en tu día' },
        { v: 'fuerza', label: 'Fuerza y energía', desc: 'Rendir más en cada sesión' },
        { v: 'recuperacion', label: 'Recuperación muscular', desc: 'Llegar listo al siguiente entreno' },
        { v: 'volumen', label: 'Subir de peso', desc: 'Me cuesta ganar peso' },
        { v: 'peso', label: 'Reducir peso corporal', desc: 'Control de peso con proteína' }
      ]
    },
    {
      id: 'estilo',
      options: [
        { v: 'pesas', label: 'Pesas', desc: 'Gimnasio clásico' },
        { v: 'bodybuilding', label: 'Bodybuilding', desc: 'Hipertrofia y definición' },
        { v: 'funcional', label: 'Funcional / híbrido', desc: 'CrossFit, HIIT, combinado' },
        { v: 'resistencia', label: 'Resistencia / cardio', desc: 'Running, ciclismo, natación' },
        { v: 'ninguno', label: 'Aún no entreno', desc: 'Quiero empezar' }
      ]
    },
    {
      id: 'dias',
      options: [
        { v: '0', label: '0 días', desc: 'Por ahora no' },
        { v: '1-3', label: '1 a 3 días' },
        { v: '4-6', label: '4 a 6 días' },
        { v: '7', label: '7 días', desc: 'Todos los días' }
      ]
    },
    {
      id: 'cafeina',
      options: [
        { v: 'si', label: 'Sí, la tolero bien' },
        { v: 'no', label: 'Prefiero sin estimulantes' },
        { v: 'nose', label: 'No estoy seguro', desc: 'Te recomendamos dosis moderadas' }
      ]
    },
    {
      id: 'edad',
      options: [
        { v: 'menor', label: 'Menos de 18' },
        { v: '18-24', label: '18 a 24' },
        { v: '25-34', label: '25 a 34' },
        { v: '35-49', label: '35 a 49' },
        { v: '50', label: '50 o más' }
      ]
    }
  ];

  var ROL_LABEL = {
    proteina: 'Base de proteína',
    creatina: 'Fuerza',
    energia: 'Pre-entreno',
    hidratacion: 'Hidratación',
    aminoacidos: 'Recuperación',
    articulaciones: 'Articulaciones',
    control: 'Control de peso'
  };
  var OBJ_LABEL = {
    masa: 'Ganar masa muscular',
    fuerza: 'Fuerza y energía',
    recuperacion: 'Recuperación muscular',
    peso: 'Reducir peso corporal',
    volumen: 'Subir de peso'
  };
  var CHIP = {
    estilo: { pesas: 'Pesas', bodybuilding: 'Bodybuilding', funcional: 'Funcional', resistencia: 'Resistencia', ninguno: 'Empezando' },
    cafeina: { si: 'Con cafeína', no: 'Sin estimulantes', nose: 'Cafeína moderada' }
  };

  function money(cents) {
    var n = cents / 100;
    var txt = n % 1 === 0 ? n.toLocaleString('es-MX') : n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + txt;
  }

  function esc(text) {
    var d = document.createElement('div');
    d.textContent = text == null ? '' : String(text);
    return d.innerHTML;
  }

  function flow(answers) {
    return QUESTIONS.filter(function (q) { return !(q.id === 'dias' && answers.estilo === 'ninguno'); });
  }

  function howMany(answers) {
    var dias = answers.estilo === 'ninguno' ? '0' : answers.dias;
    if (dias === '0') return 1;
    if (dias === '1-3') return 2;
    return 3;
  }

  // ---------- Motor ----------
  function recommend(data, a) {
    var maxStim = (a.cafeina === 'no' || a.edad === 'menor') ? 0 : (a.cafeina === 'nose' ? 1 : 2);
    var rows = data.products
      .filter(function (p) { return p.a && p.stim <= maxStim; })
      .map(function (p) {
        var s = 0;
        if ((p.obj || []).indexOf(a.objetivo) > -1) s += 3.5;
        else if ((p.apo || []).indexOf(a.objetivo) > -1) s += 1;
        if ((p.est || []).indexOf(a.estilo) > -1) s += 2;
        if (a.cafeina === 'si' && p.stim === 2) s += 0.5;
        if (a.edad === '50' && p.rol === 'articulaciones') s += 1;
        if (a.objetivo === 'volumen' && p.rol === 'proteina' && (p.obj || []).indexOf('volumen') > -1 && p.n.toLowerCase().indexOf('gainer') > -1) s += 2.5;
        s += (p.best || 0) * 0.3 + (p.r || 0) * Math.min(p.rc || 0, 10) * 0.001;
        return { p: p, s: s };
      })
      .filter(function (x) { return x.s >= 1; });
    rows.sort(function (x, y) { return y.s - x.s; });

    var n = howMany(a);
    var used = {};
    var out = [];
    rows.forEach(function (x) {
      if (out.length >= n || used[x.p.rol]) return;
      used[x.p.rol] = true;
      out.push(x.p);
    });

    var notes = [];
    if (a.edad === 'menor') notes.push('Por tu edad no incluimos productos con estimulantes. Antes de empezar, platícalo con tus papás o con un profesional de la salud.');

    return { items: out, notes: notes, combo: out.length >= 2 ? bestCombo(data, out, maxStim) : null };
  }

  // Solo se sugiere un combo si incluye 2+ productos recomendados Y cuesta menos que comprarlos sueltos
  function bestCombo(data, items, maxStim) {
    var keys = items.map(function (p) { return p.k; });
    var byKey = {};
    data.products.forEach(function (p) { byKey[p.k] = p; });
    var best = null;
    (data.combos || []).forEach(function (c) {
      var overlap = 0;
      var loose = 0;
      var ok = true;
      c.items.forEach(function (it) {
        var p = byKey[it.k];
        if (!p || p.stim > maxStim) { ok = false; return; }
        var price = p.s[it.s];
        if (!price) { ok = false; return; }
        loose += price;
        if (keys.indexOf(it.k) > -1) overlap += 1;
      });
      if (!ok || overlap < 2 || c.p >= loose) return;
      var cand = {
        handle: c.k, name: c.n, url: c.u, price: c.p, loose: loose, save: loose - c.p,
        pct: Math.round((1 - c.p / loose) * 100), overlap: overlap, total: c.items.length
      };
      if (!best || cand.overlap > best.overlap || (cand.overlap === best.overlap && cand.save > best.save)) best = cand;
    });
    return best;
  }

  // ---------- Interfaz ----------
  function init(root) {
    if (root.dataset.qzReady) return;
    root.dataset.qzReady = '1';

    var data;
    try { data = JSON.parse(root.querySelector('[data-qz-data]').textContent); } catch (e) { return; }
    if (!data || !data.products || !data.products.length) return;

    var el = {
      stage: root.querySelector('[data-qz-stage]'),
      loading: root.querySelector('[data-qz-loading]'),
      load: root.querySelector('[data-qz-load]'),
      result: root.querySelector('[data-qz-result]'),
      opts: root.querySelector('[data-qz-opts]'),
      title: root.querySelector('[data-qz-title]'),
      count: root.querySelector('[data-qz-count]'),
      bar: root.querySelector('[data-qz-bar]'),
      back: root.querySelector('[data-qz-back]'),
      grid: root.querySelector('[data-qz-grid]'),
      pool: root.querySelector('[data-qz-pool]'),
      hero: root.querySelector('[data-qz-hero]'),
      eyebrow: root.querySelector('[data-qz-eyebrow]'),
      obj: root.querySelector('[data-qz-obj]'),
      notes: root.querySelector('[data-qz-notes]'),
      again: root.querySelector('[data-qz-again]')
    };

    var state = { step: 0, answers: {} };

    function paint() {
      var list = flow(state.answers);
      var q = list[Math.min(state.step, list.length - 1)];
      el.title.textContent = (data.titles && data.titles[q.id]) || '';
      el.count.textContent = 'Pregunta ' + (state.step + 1) + ' de ' + list.length;
      el.bar.style.width = Math.round(((state.step + 1) / list.length) * 100) + '%';
      el.back.hidden = state.step === 0;
      el.opts.innerHTML = q.options.map(function (o, i) {
        return '<button type="button" class="fnt-qz__opt" data-qz-pick="' + o.v + '" aria-pressed="' +
          (state.answers[q.id] === o.v) + '">' +
          '<span class="fnt-qz__opt-num">0' + (i + 1) + '</span>' +
          '<span class="fnt-qz__opt-txt"><span class="fnt-qz__opt-label">' + esc(o.label) + '</span>' +
          (o.desc ? '<span class="fnt-qz__opt-desc">' + esc(o.desc) + '</span>' : '') + '</span>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' +
          '</button>';
      }).join('');
      el.opts.style.animation = 'none';
      void el.opts.offsetWidth;
      el.opts.style.animation = '';
      el.opts.querySelectorAll('[data-qz-pick]').forEach(function (b) {
        b.addEventListener('click', function () { pick(q.id, b.dataset.qzPick, b); });
      });
    }

    function pick(qid, value, btn) {
      state.answers[qid] = value;
      el.opts.querySelectorAll('[data-qz-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      setTimeout(function () {
        var list = flow(state.answers);
        if (state.step + 1 < list.length) {
          state.step += 1;
          paint();
        } else {
          armando();
        }
      }, 240);
    }

    function armando() {
      el.stage.hidden = true;
      el.result.hidden = true;
      if (el.hero) el.hero.hidden = true;
      el.loading.hidden = false;
      var a = state.answers;
      el.load.innerHTML = [
        'Objetivo: ' + (OBJ_LABEL[a.objetivo] || ''),
        'Estilo: ' + (CHIP.estilo[a.estilo] || ''),
        'Cafeína: ' + (CHIP.cafeina[a.cafeina] || '')
      ].map(function (t) { return '<span><b>✓</b> ' + esc(t) + '</span>'; }).join('');
      setTimeout(show, 900);
    }

    function toPool() {
      root.querySelectorAll('[data-qz-prod], [data-qz-combo-prod]').forEach(function (node) {
        node.hidden = true;
        el.pool.appendChild(node);
      });
    }

    function show() {
      var a = state.answers;
      var r = recommend(data, a);
      if (!r.items.length) { el.loading.hidden = true; el.stage.hidden = false; return; }

      el.eyebrow.textContent = (data.eyebrow || 'Tu rutina F&NT') + ' · ' +
        r.items.length + (r.items.length === 1 ? ' producto' : ' productos');
      el.obj.textContent = OBJ_LABEL[a.objetivo] || '';
      if (el.notes) {
        el.notes.innerHTML = r.notes.map(function (n) { return '<p>' + esc(n) + '</p>'; }).join('');
      }

      toPool();

      r.items.forEach(function (p, i) {
        var node = root.querySelector('[data-qz-prod="' + p.k + '"]');
        if (!node) return;
        var num = node.querySelector('[data-qz-num]');
        var rol = node.querySelector('[data-qz-role]');
        var ess = node.querySelector('[data-qz-ess]');
        if (num) num.textContent = '0' + (i + 1);
        if (rol) rol.textContent = ROL_LABEL[p.rol] || '';
        if (ess) ess.hidden = i !== 0;
        node.hidden = false;
        el.grid.appendChild(node);
      });

      // El combo entra como una tarjeta más, al final
      if (r.combo) {
        var cnode = root.querySelector('[data-qz-combo-prod="' + r.combo.handle + '"]');
        if (cnode) {
          var cnum = cnode.querySelector('[data-qz-num]');
          var save = cnode.querySelector('[data-qz-save]');
          var note = cnode.querySelector('[data-qz-combo-note]');
          if (cnum) cnum.textContent = '0' + (r.items.length + 1);
          if (save) save.textContent = 'Ahorras ' + money(r.combo.save) + ' (' + r.combo.pct + '%)';
          if (note) {
            note.textContent = r.combo.overlap === r.combo.total
              ? 'Trae los ' + r.combo.total + ' productos de tu rutina, más shaker, por ' + money(r.combo.price) + ' en lugar de ' + money(r.combo.loose) + '.'
              : 'Trae ' + r.combo.overlap + ' de tus productos, más shaker, por ' + money(r.combo.price) + ' en lugar de ' + money(r.combo.loose) + '.';
          }
          cnode.hidden = false;
          el.grid.appendChild(cnode);
        }
      }

      // Siempre 4 columnas en compu: las tarjetas conservan el tamaño del catálogo
      if (window.matchMedia('(min-width: 750px)').matches) {
        el.grid.style.gridTemplateColumns = 'repeat(4, minmax(0, 1fr))';
      } else {
        el.grid.style.gridTemplateColumns = '';
      }

      el.loading.hidden = true;
      el.stage.hidden = true;
      el.result.hidden = false;
      if (el.hero) el.hero.hidden = false;

      var detail = { answers: a, products: r.items.map(function (p) { return p.k; }), combo: r.combo ? r.combo.name : null };
      document.dispatchEvent(new CustomEvent('fnt:quiz-completed', { detail: detail }));
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('fnt_quiz_completed', detail);
      }
    }

    el.back.addEventListener('click', function () {
      state.step = Math.max(0, state.step - 1);
      paint();
    });

    el.again.addEventListener('click', function () {
      state = { step: 0, answers: {} };
      toPool();
      el.result.hidden = true;
      el.loading.hidden = true;
      if (el.hero) el.hero.hidden = true;
      el.stage.hidden = false;
      paint();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Objetivo desde la URL (?objetivo=fuerza) para campañas
    var params = new URLSearchParams(window.location.search);
    var pre = params.get('objetivo');
    if (pre && QUESTIONS[0].options.some(function (o) { return o.v === pre; })) {
      state.answers.objetivo = pre;
      state.step = 1;
    }

    paint();
  }

  function boot() {
    document.querySelectorAll('[data-fnt-qz]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
